import React from 'react';
import {
  titleUI,
  yesNoUI,
  yesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { VaDetails } from '@department-of-veterans-affairs/component-library/dist/react-bindings';
import { IncomeAssetStatementFormAlert } from '../../../../components/FormAlerts';
import content from '../../utils/content.json';

const MarketableInfo = () => (
  <VaDetails label={content['financial-info-marketable-land-info-title']}>
    <ul>
      <li>{content['financial-info-marketable-land-info-slightly-over']}</li>
      <li>{content['financial-info-marketable-land-info-inaccessible']}</li>
      <li>{content['financial-info-marketable-land-info-zoning']}</li>
    </ul>
  </VaDetails>
);

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['financial-info-marketable-land-title']),
    landMarketable: yesNoUI({
      title: content['financial-info-marketable-land-question'],
    }),
    incomeAssetStatementFormAlert: {
      'ui:description': IncomeAssetStatementFormAlert,
      'ui:options': {
        hideIf: formData => formData?.landMarketable !== true,
        displayEmptyObjectOnReview: true,
      },
    },
    'view:marketableInfo': {
      'ui:description': MarketableInfo,
      'ui:options': {
        displayEmptyObjectOnReview: true,
      },
    },
  },
  schema: {
    type: 'object',
    required: ['landMarketable'],
    properties: {
      landMarketable: yesNoSchema,
      incomeAssetStatementFormAlert: {
        type: 'object',
        properties: {},
      },
      'view:marketableInfo': {
        type: 'object',
        properties: {},
      },
    },
  },
};
